"use client";
import { useDialogProviderContext } from "./dialog-context.js";
import { useDisclosure } from "../disclosure/disclosure.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
import { getPopupRole, invariant } from "@ariakit/utils";
import { useStoreState } from "@ariakit/react-store";
//#region src/dialog/dialog-disclosure.tsx
const TagName = "button";
/**
* Returns props to create a `DialogDisclosure` component.
* @see https://ariakit.com/components/dialog
* @example
* ```jsx
* const store = useDialogStore();
* const props = useDialogDisclosure({ store });
* <Role {...props}>Disclosure</Role>
* <Dialog store={store}>Content</Dialog>
* ```
*/
const useDialogDisclosure = createHook(function useDialogDisclosure({ store, ...props }) {
	const context = useDialogProviderContext();
	store = store || context;
	invariant(store, process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component.");
	props = {
		"aria-haspopup": getPopupRole(useStoreState(store, "contentElement"), "dialog"),
		...props
	};
	props = useDisclosure({
		store,
		...props
	});
	return props;
});
/**
* Renders a button that toggles the visibility of a
* [`Dialog`](https://ariakit.com/reference/dialog) component when clicked.
* @see https://ariakit.com/components/dialog
* @example
* ```jsx {2}
* <DialogProvider>
*   <DialogDisclosure>Disclosure</DialogDisclosure>
*   <Dialog>Content</Dialog>
* </DialogProvider>
* ```
*/
const DialogDisclosure = forwardRef(function DialogDisclosure(props) {
	return createElement(TagName, useDialogDisclosure(props));
});
//#endregion
export { DialogDisclosure, useDialogDisclosure };

//# sourceMappingURL=dialog-disclosure.js.map